import { JSX, useContext } from 'react'
import { Handle, Position, useReactFlow, ReactFlowInstance, Edge, Node } from '@xyflow/react';
import HubIcon from '@mui/icons-material/Hub';
import SettingsIcon from '@mui/icons-material/Settings';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import CheckIcon from "@mui/icons-material/Check";

function WorkflowNode({ id, data }: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();

    function handleShowForm(): void {
        let node: Node = reactFlowInstance.getNode(id);
        context.setNodeForEdit(node);
    }

    function getAiLogo(): string | JSX.Element {
        if (data.llm === undefined || data.llm === '') {
            return '';
        }
        let llmNamePrint = data.llm;
        if (llmNamePrint.includes('ollama')) {
            llmNamePrint = llmNamePrint.replace('ollama-', '');
        }
        if (llmNamePrint.includes('llama')) {
            return (
                <span className="llama llm-icon" title={ llmNamePrint } />
            );
        } else if(llmNamePrint.includes('deepseek')) {
            return (
                <span className="deepseek llm-icon" title={ llmNamePrint} />
            );
        }
    }

    // The node title is clamped to two lines in CSS, so it no longer has to be
    // cut off mid-word at fifteen characters here.
    const label: string = data.label ?? '';
    
    let hideElements: string[] = [];
    const edges: Edge[] = reactFlowInstance.getEdges();
    let thisNodeEdges: Edge[] = [];
    edges.forEach( (edge: Edge): void => {
        if (edge.target === id && edge.sourceHandle === 'supervisor-source') {
            thisNodeEdges.push(edge);
            if (edge.targetHandle.includes('-two')) {
                hideElements.push('node-target-one');
            } else {
                hideElements.push('node-target-two');
            }
            if (!hideElements.includes('node-source')) {
                hideElements.push('node-source');
            }
        }
    });

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node agent " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            { (!hideElements.includes('node-target-one')) &&
                <Handle type="target" id="node-target-one" position={Position.Top}>
                    <span className="handle-label top" >{ "Input 2" }</span>
                </Handle>
            }
            { (!hideElements.includes('node-target-two')) &&
                <Handle type="target" id="node-target-two" position={Position.Left}>
                    <span className="handle-label left" >{ "Input 1" }</span>
                </Handle>
            }


            <div className="node__layout workflow">
                <div className="layout__top">
                    <span className="agent-icon" />
                    { /* The node's own name. The type ("Agent") is already set
                         by the stylesheet's eyebrow, so it is not repeated. */ }
                    <span className={ "label-span" }>{ label }</span>
                    { (data?.agent_type === 'Supervisor') &&
                        <span className="supervisor-icon" />
                    }
                </div>
                <div className="layout__bottom">
                    <div className="icons">
                        { (typeof data !== "undefined" && typeof data.label !== "undefined" && data.label.length > 0) &&
                            <>
                                { getAiLogo() }
                                { (data?.tools?.length > 0) &&
                                    <span className="toolbox-icon" title="Agent's Toolbox"/>
                                }
                            </>
                        }
                        <span className="action-span nodrag" onClick={ handleShowForm } >
                            <SettingsIcon />
                        </span>
                    </div>
                </div>
            </div>
            { (data?.agent_type !== 'Supervisor') &&
                <Handle
                    type="source"
                    id="tool-source"
                    position={Position.Right} >
                    <span className="handle-label right" >{ "Tools" }</span>
                </Handle>
            }

            { (data?.agent_type === 'Supervisor' && thisNodeEdges.length === 0) &&
                <Handle
                    type="source"
                    id="supervisor-source"
                    position={Position.Right} >
                    <span className="handle-label right" >{ "Agents" }</span>
                </Handle>
            }
            { (!hideElements.includes('node-source')) &&
                <Handle type="source" id="node-source" position={Position.Bottom} >
                    <span className="handle-label bottom" >{"Output"}</span>
                </Handle>
            }

        </div>
    );
}

export default WorkflowNode;